/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2021, Zumper
 * @description z-index constants
 */

export const Z_INDEX_GROUP_NEG = -100 as const
export const Z_INDEX_GROUP_1 = 100 as const
export const Z_INDEX_GROUP_2 = 200 as const
export const Z_INDEX_GROUP_3 = 300 as const
export const Z_INDEX_GROUP_4 = 400 as const
export const Z_INDEX_GROUP_5 = 500 as const
export const Z_INDEX_GROUP_6 = 600 as const
export const Z_INDEX_GROUP_7 = 700 as const
export const Z_INDEX_GROUP_8 = 800 as const
export const Z_INDEX_GROUP_9 = 900 as const
export const Z_INDEX_GROUP_10 = 1000 as const
export const Z_INDEX_GROUP_11 = 1450 as const
export const Z_INDEX_GROUP_99 = 9900 as const

// Z_-NDEX_x Predefined Layers
// --------------------------------------------------
export const Z_INDEX_OVERLAY = 100 as const
export const Z_INDEX_MENU_SIDEBAR = 900 as const
export const Z_INDEX_DROPDOWN = 1010 as const
export const Z_INDEX_STICKY = 1020 as const
export const Z_INDEX_FIXED = 1030 as const
export const Z_INDEX_MODAL_BACKDROP = 1399 as const
export const Z_INDEX_MODAL = 1400 as const // var(--chakra-zIndices-modal)
export const Z_INDEX_POPOVER = 1500 as const
export const Z_INDEX_TOOLTIP = 1600 as const
export const Z_INDEX_BUTTER = 1700 as const
